module.exports = __webpack_public_path__ + "static/media/optimma-logo.c3dba601.svg";